import { isAddress } from 'viem'
import { shortenWalletAddress } from '@utils/artists'
import { User } from '@privy-io/react-auth'

/**
 * Generates a user display name based on profile data and wallet addresses
 */
export function getUserDisplayName({
  name,
  username,
  primaryWallet,
  fallbackIdentifier
}: {
  name?: string | null
  username?: string | null
  primaryWallet?: string
  fallbackIdentifier?: string
}): string {
  // try name, then username
  if (name) return name
  if (username) return username

  // if have primary wallet, shorten it
  if (primaryWallet) {
    return shortenWalletAddress(primaryWallet)
  }

  // use fallback identifier (could be walletOrUsername param)
  if (fallbackIdentifier) {
    // If valid address, shorten it
    if (isAddress(fallbackIdentifier)) {
      return shortenWalletAddress(fallbackIdentifier)
    }
    return fallbackIdentifier
  }

  return 'Unknown User'
}

export function getPrivySignUpType(privyUser: User): 'email' | 'wallet' {
  const userHasLinkedEmail = Boolean(privyUser.email)
  const userHasLinkedExternalWallet = Boolean(
    privyUser.linkedAccounts.find((account) => account.type === 'wallet' && account.connectorType !== 'embedded')
  )
  return userHasLinkedEmail && !userHasLinkedExternalWallet ? 'email' : 'wallet'
}
